function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
define('TescoMobile_ClubCard/js/view/clubcard-selection-modal',['jquery', 'mage/translate', 'Magento_Ui/js/modal/confirm', 'TescoMobile_Catalog/js/model/deal', 'Magento_Catalog/js/price-utils', 'uiRegistry', 'Magento_Customer/js/customer-data'], function ($, $t, confirmModal, deal, priceUtils, registry, customerData) {
  'use strict';

  return function (config) {
    const clubcardProvider = registry.get('tm-clubcard-price-provider');
    const selectionModal = registry.get('tm-clubcard-price-modal');
    const body = $('body');
    const isPlp = body.hasClass('catalog-category-view');
    return confirmModal(_objectSpread({
      title: `<div class="clubcard-logo"><span>Lower prices</span><span>Clubcard Price</span></div>
                ${$t('Do you have a Tesco Clubcard?')}`,
      content: selectionModal.content,
      modalClass: 'confirm-popup clubcard-price-modal',
      clickableOverlay: false,
      closed: function () {
        var _customerData$get;
        if (isPlp) {
          clubcardProvider.clubCardPrice(null);
        }
        if ((_customerData$get = customerData.get('customer')()) !== null && _customerData$get !== void 0 && _customerData$get.firstname) {
          body.trigger('upgrade-options-submited');
          body.trigger('add-to-cart-button-change-state', {
            enabled: true
          });
        }
      },
      buttons: [{
        text: $t('Yes, pay %1 a month').replace('%1', priceUtils.formatPrice(clubcardProvider.clubCardPrice())),
        class: 'action primary',
        click: function (event) {
          const clubcardPriceFlag = clubcardProvider.getClubCardPriceFlagElement();
          clubcardPriceFlag.val(1);
          this.closeModal(event, true);
        }
      }, {
        text: $t('No, pay %1 a month').replace('%1', priceUtils.formatPrice(clubcardProvider.getMonthlyTotal())),
        class: 'action secondary',
        click: function (event) {
          const clubcardPriceFlag = clubcardProvider.getClubCardPriceFlagElement();
          clubcardPriceFlag.val(0);
          this.closeModal(event, true);
        }
      }]
    }, config));
  };
});

